import { useProcess, useSelect } from '~/store'
import { organizationBillingModule } from './organization-billing-module'

export function useOrganizationBilling() {
  const organizationBilling = useProcess('organizationBilling')
  const organizationBillingState = useSelect('organizationBilling', (s) => s)

  return [organizationBillingState, organizationBilling.send] as const
}
